
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/danh-muc/[slug]",
      function () {
        return require("private-next-pages/danh-muc/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/danh-muc/[slug]"])
      });
    }
  